var _defs, _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11108",
    "data-name": "Group 11108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.354,
    height: 27.917,
    viewBox: "0 0 22.354 27.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3278",
    "data-name": "Rectangle 3278",
    width: 22.354,
    height: 27.917,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3277",
    "data-name": "Rectangle 3277",
    width: 22.354,
    height: 7.692,
    transform: "translate(0 20.225)",
    fill: "#ed1c24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29027",
    "data-name": "Path 29027",
    d: "M0,.011V20.3H22.354V4.334h-.012L17.533.011Z",
    transform: "translate(0 -0.009)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11099",
    "data-name": "Group 11099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11098",
    "data-name": "Group 11098",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29028",
    "data-name": "Path 29028",
    d: "M25.67,148.128h2.709a1.854,1.854,0,0,1,1.326.421,1.579,1.579,0,0,1,.441,1.2,1.627,1.627,0,0,1-.48,1.248,2.081,2.081,0,0,1-1.466.45h-.892V153.4H25.67Zm1.637,2.249h.4a1.027,1.027,0,0,0,.662-.164.528.528,0,0,0,.191-.419.586.586,0,0,0-.165-.421.858.858,0,0,0-.622-.173h-.464Z",
    transform: "translate(-21.944 -126.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29029",
    "data-name": "Path 29029",
    d: "M62.525,148.128h2.421a2.9,2.9,0,0,1,1.157.194,1.881,1.881,0,0,1,.729.558,2.308,2.308,0,0,1,.417.846,3.924,3.924,0,0,1,.13,1.022,3.546,3.546,0,0,1-.192,1.311,2.17,2.17,0,0,1-.534.781,1.742,1.742,0,0,1-.734.419,3.781,3.781,0,0,1-.971.144H62.525Zm1.63,1.195V152.2h.4a1.679,1.679,0,0,0,.727-.113.769.769,0,0,0,.338-.4,2.488,2.488,0,0,0,.122-.916,1.778,1.778,0,0,0-.273-1.148,1.157,1.157,0,0,0-.907-.309Z",
    transform: "translate(-53.449 -126.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29030",
    "data-name": "Path 29030",
    d: "M101.91,148.128h4.03v1.133h-2.393v.921h2.044v1.065h-2.044V153.4H101.91Z",
    transform: "translate(-87.117 -126.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29031",
    "data-name": "Path 29031",
    d: "M125.586,4.325h-4.811V0l0,0Z",
    transform: "translate(-103.244 0)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29032",
    "data-name": "Path 29032",
    d: "M46.975,58.193l-.068,0a.7.7,0,0,1-.525-.235.734.734,0,0,1-.091-.664,1.921,1.921,0,0,1,.254-.554,2.271,2.271,0,0,1,1.29-.828l.017-.006c.484-.165.825-.287,1.072-.38a13.053,13.053,0,0,0,.643-1.293,13.607,13.607,0,0,0,.571-1.672,10,10,0,0,1-.6-1.452,3.255,3.255,0,0,1-.153-.805,1.4,1.4,0,0,1,.048-.439l0-.012c.054-.2.167-.6.522-.7a.72.72,0,0,1,.7.2.744.744,0,0,1,.191.4,1.334,1.334,0,0,1,.012.308,10.63,10.63,0,0,1-.3,2.195q-.032.138-.065.27.395.791.986,1.778c.079.132.149.246.233.36a13.774,13.774,0,0,1,1.523-.3,1.8,1.8,0,0,1,1.654.364.96.96,0,0,1,.271.839.767.767,0,0,1-.5.452,2.327,2.327,0,0,1-.478.117,3.2,3.2,0,0,1-2.531-1.024l-.065-.073c-.358.088-.745.187-1.163.295a3.252,3.252,0,0,0-.718.231c-.1.048-.248.114-.545.229-.18.33-.395.717-.652,1.181a2.1,2.1,0,0,1-1.082,1.144,1.507,1.507,0,0,1-.452.072m1.7-2.218c-.2.071-.432.153-.716.25l-.017.006a1.976,1.976,0,0,0-1.119.7c-.185.276-.311.657-.181.818a.676.676,0,0,0,.678.055c.42-.136.638-.53.891-.986.174-.313.327-.59.464-.838m3.287-1.025a3.6,3.6,0,0,0,.629.484,2.822,2.822,0,0,0,.7.311,2.061,2.061,0,0,0,1.242-.04.487.487,0,0,0,.3-.241c.055-.169-.106-.406-.2-.508-.392-.431-1.279-.334-2.679-.007m-1.6-1.945c-.168.563-.343,1-.483,1.352a10.318,10.318,0,0,1-.468.971l.152-.069a3.531,3.531,0,0,1,.776-.252c.364-.093.7-.181,1.023-.26-.065-.1-.119-.187-.171-.273q-.476-.8-.829-1.47m-.227-3.541a.33.33,0,0,0-.086.011c-.17.046-.248.329-.286.465l0,.012a1.78,1.78,0,0,0,.1,1.057,8.435,8.435,0,0,0,.4,1.034,11.726,11.726,0,0,0,.26-2,.608.608,0,0,0-.11-.453.4.4,0,0,0-.28-.122",
    transform: "translate(-39.54 -41.996)",
    fill: "red"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.a79eea71781bfa5e7348224922eef037.svg";
export { ForwardRef as ReactComponent };